export default "__VITE_ASSET__87825a17__"